/* eslint-disable i18next/no-literal-string -- TanStack cache key roots */
/**
 * Roots of React Query keys shared across slices.
 *
 * The session list queries live in `features/sessions` (sessions page) and
 * `features/dashboard` (recent sessions), but `features/chats` must
 * invalidate them when a new chat session (context) is created — the global
 * 5-minute `staleTime` otherwise keeps serving a cached list that is missing
 * the new session. Keeping the roots here prevents the slices from drifting
 * apart on raw string literals.
 */
export const SESSIONS_QUERY_KEY_ROOT = 'sessions';
export const RECENT_SESSIONS_QUERY_KEY_ROOT = 'recent-sessions';

/**
 * Chat history cache (`features/chats` owns the query, `features/ai` drops
 * the entry when leaving a session it streamed messages into — the query is
 * configured with `staleTime: Infinity` + `refetchOnMount: false`, so a
 * stale entry would otherwise replay the pre-conversation history forever).
 */
export const CHAT_HISTORY_QUERY_KEY_ROOT = 'chat-history';
